import { settingsActions } from './settings-slice'
import store from './index'
import { handleError, handleSessionExpired } from './error-handler';

export const fetchWebSettings = () => {
    return async (dispatch) => {
        const fetchWebSettings = async () => {
            var bearer = 'Bearer ' + localStorage.getItem('token');
            const url = store.getState().auth.url
            const response = await fetch(url + 'api/websettings',{
                headers:{
                    'Authorization': bearer,
                }
            });

            if (!response.ok) {
                if(response.status === 401){ 
                    handleSessionExpired(dispatch, bearer)
                    throw new Error('Your session has expired. Please log in again.')
                }
                else{ throw new Error('Could not fetch settings.') }
            }
            const data = await response.json()
            return data;
        };

        const fetchSharedSettings = async () => {
            var bearer = 'Bearer ' + localStorage.getItem('token');
            const url = store.getState().auth.url
            const response = await fetch(url + 'api/sharedsettings',{
                headers:{
                    'Authorization': bearer,
                }
            });

            if (!response.ok) {
                if(response.status === 401){ 
                    handleSessionExpired(dispatch, bearer)
                    throw new Error('Your session has expired. Please log in again.')
                }
                else{ throw new Error('Could not fetch shared settings.') }
            }
            const data = await response.json()
            return data;
        };

        try {
            const [settingsData, sharedSettingsData] = await Promise.all([
                fetchWebSettings(),
                fetchSharedSettings()
            ]);
            dispatch(settingsActions.setWebSettings(settingsData));
            dispatch(settingsActions.setSharedSettings(sharedSettingsData));
        } catch (error) {
           handleError(dispatch, error)
        }
    };

    
};

export const fetchDonorSettings = () => {
    return async (dispatch) => {
        const fetchData = async () => {
            var bearer = 'Bearer ' + localStorage.getItem('token');
            const url = store.getState().auth.url
            const response = await fetch(url + 'api/donor-settings',{
                headers:{
                    'Authorization': bearer,
                }
            });

            if (!response.ok) {
                if(response.status === 401){ 
                    handleSessionExpired(dispatch, bearer)
                    throw new Error('Your session has expired. Please log in again.')
                }
                else{ throw new Error('Could not fetch donor settings.') }
            }
            const data = await response.json()
            return data;
        };

        try {
            const settingsData = await fetchData()
            dispatch(settingsActions.setDonorSettings(settingsData))

        } catch (error) {
           handleError(dispatch, error)
        }
    };
};


